import { X as Close } from '@styled-icons/bootstrap/X';
import IntegrationAnalyticsContext from 'components/Integrations/Shared/IntegrationAnalyticsProvider';
import { CookieBanner } from 'components/Shared';
import { Map, ProductJourneyContainer } from 'components/Shared/ProductJourney';
import ActiveProvider from 'components/Shared/ProductJourney/Context/ActiveContext';
import Logo from 'images/seedtrace_logo_white.svg';
import React, { useContext } from 'react';
import styled from 'styled-components';
const Container = styled.div `
  position: relative;
  overflow: hidden;
  width: 100%;
  border-radius: 4px;

  @media screen and (min-width: calc(680px + 32px)) {
    height: 100%;
  }
`;
const ScrollContainer = styled.div `
  height: 100%;
  max-height: 100%;
  overflow: auto;
  border-radius: 4px;
  font-family: Lato;
`;
const LogoContainer = styled.div `
  position: absolute;
  bottom: 0;
  left: 0;
  transform: translateY(calc(100% + 4px));
  width: 80px;
  height: 30px;

  a {
    text-decoration: none !important;
  }
`;
const CloseButton = styled.button `
  position: absolute !important;
  top: 0 !important;
  right: 0 !important;
  transform: translate3d(16px, -80%, 0);
  background: transparent !important;
  border: none !important;
  outline: none !important;
  cursor: pointer !important;
  padding: 8px !important;
`;
const StyledClose = styled(Close) `
  color: #fff;
`;
const ModalContent = ({ supplyChain, lang, productId, latestBatch, handleClose, }) => {
    const { setStatisticsAccepted, trackSteps } = useContext(IntegrationAnalyticsContext);
    return (React.createElement(ActiveProvider, { lang: lang, productId: productId, supplyChain: supplyChain, latestBatch: latestBatch, trackSteps: trackSteps, isIntegration: true },
        React.createElement(ScrollContainer, null,
            React.createElement(CookieBanner, { onGranted: () => setStatisticsAccepted(true), preview: false, positionAbsolute: true }),
            React.createElement(Container, null,
                React.createElement(ProductJourneyContainer, { MapComponent: Map, showProductJourneyCards: true }))),
        React.createElement(CloseButton, { onClick: handleClose },
            React.createElement(StyledClose, { size: 30 })),
        React.createElement(LogoContainer, null,
            React.createElement("a", { href: "https://seedtrace.org", target: "_blank", rel: "noopener noreferrer" },
                React.createElement(Logo, null)))));
};
export default ModalContent;
